import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLSettingsClient, TermsAndConditionsModel } from "./api/cplapi/CPLAPI";

export interface ISettingsService {
  getTermsAndConditions(): Promise<TermsAndConditionsModel>;
  updateTermsAndConditions(updatedContent: string): Promise<void>;
  useExternalPrinting(): Promise<boolean>;
}

@injectable()
export class SettingsService implements ISettingsService {
  @inject(SERVICE_TYPES.CPLSettingsClient) cplSettingsClient!: ICPLSettingsClient;

  getTermsAndConditions(): Promise<TermsAndConditionsModel> {
    return this.cplSettingsClient.getTermsAndConditions();
  }

  updateTermsAndConditions(updatedContent: string): Promise<void> {
    return this.cplSettingsClient.updateTermsAndConditions(updatedContent);
  }

  useExternalPrinting(): Promise<boolean> {
    return this.cplSettingsClient.useExternalPrinting();
  }
}
